import classnames from 'classnames/bind'
import React from 'react'

import BoxDoubleImage, {
  BoxDoubleImageProps,
} from '~/components/BoxDoubleImage'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoDoubleImageProps {
  className?: string
  items?: BoxDoubleImageProps[]
}

function EditoDoubleImage({ className, items }: EditoDoubleImageProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <div className={cx(css.EditoDoubleImage, className)}>
      <div className={cx(css.grid, gridStyle)}>
        <div className={css.content}>
          {items?.map((item, index) => {
            const isFirstBox = index === 0

            return (
              <BoxDoubleImage
                className={cx(css.box, {
                  isFirstBox,
                })}
                key={`edito_double_image_${index}`}
                {...item}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

EditoDoubleImage.defaultProps = {}

export default EditoDoubleImage
